import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import CheckEligibility from '../../services/check-eligibility.service';
import { AnalyticsService } from '../../services/analytics.service';
import axios from 'axios';
import './form-check-eligibility-business.component.scss';
import * as $ from 'jquery';
var FormCheckEligibilityBusiness = /** @class */ (function (_super) {
    tslib_1.__extends(FormCheckEligibilityBusiness, _super);
    function FormCheckEligibilityBusiness(element, analyticsService) {
        var _this = _super.call(this, element) || this;
        _this.valueClient = false;
        _this.valueFormValid = false;
        _this.valueNationality = "";
        _this.valueResidence = "";
        _this.valueModalId = "";
        _this.valueDateOfBirth = "";
        return _this;
    }
    FormCheckEligibilityBusiness.prototype.init = function () {
        this.checkEligibility = new CheckEligibility();
        this.formCheckEligibility = this.element.querySelector('form#business-check-eligibility');
        this.radioRelationship = Array.from(this.element.querySelectorAll('.js-existing_relationship'));
        this.inputDateCompany = this.element.querySelector('.js-date-established');
        this.radioPrimaryBusiness = Array.from(this.element.querySelectorAll('.js-primary_business'));
        this.dropdownTurnover = this.element.querySelector('.js-turnover');
        this.dropdownEmployees = this.element.querySelector('.js-employees');
        this.submitButton = Array.from(this.element.querySelectorAll('.js-check-eligibility-submit__button'));
        this.containerFields = this.element.querySelector('.form__fields--container');
        this.containerNote = this.element.querySelector('.apply-now__note');
        this.containerButtons = this.element.querySelector('.apply-now__buttons');
        this.containerThankyou = this.element.querySelector('.form__thankyou--container');
        this.containerInvalid = this.element.querySelector('.js-invalid-container');
        this.containerValid = this.element.querySelector('.js-valid-container');
        this.containerValidExisting = this.element.querySelector('.js-valid-existing-container');
        this.containerGroupCheckEligibility = this.element.querySelector('.form-check-eligibility-business__group[data-group-name=eligibility-group]');
        this.containerLoader = this.element.querySelector('.form__loader--container');
        this.valueModalId = this.element.closest('.js-apply-now-modal').getAttribute('id');
        this.containerModal = this.element.closest('.form-container');
        this.closeButton = this.containerModal.querySelector('.js-apply-now-modal-close');
        this.valuesJson = {
            operation: "open",
            category: "business",
            leadType: "Call Back_NewBusines",
            leadCTA: "CHECK ELIGIBILITY",
            eligibilityCTA: "Call Me Back",
            leadStatus: "Open",
            eligibilityFormId: "",
            clientSBG: "N",
            sbPOR: "",
            dateEstablished: "",
            primeBusinessAfrica: "",
            companyAnnualTurnover: "",
            employeesN: "",
            productName: "",
            pageUrl: ""
        };
    };
    FormCheckEligibilityBusiness.prototype.bindEvents = function () {
        var _this = this;
        // radio buttons - relationship
        this.radioRelationship.map(function (item) { return item.addEventListener('click', function (event) {
            var element = event.target;
            if (element.value == "no") {
                _this.valuesJson.clientSBG = 'N';
                _this.valuesJson.sbPOR = '';
                _this.valuesJson.leadType = 'Call Back_NewBusines';
                var parentParent = element.closest('.form-check-eligibility-business__group');
                var oldInput = _this.element.querySelector('.js-manager-name-container');
                parentParent.removeChild(oldInput);
            }
            else {
                _this.valuesJson.clientSBG = 'Y';
                _this.valuesJson.leadType = 'CallBack_IBB Sales';
                var parentParent = element.closest('.form-check-eligibility-business__group');
                var parent_1 = element.closest('.form__group');
                var newContainer = document.createElement('div');
                newContainer.classList.add('form__group');
                newContainer.classList.add('js-manager-name-container');
                var newLabel = document.createElement('label');
                newLabel.classList.add('form__label');
                newLabel.innerHTML = "Standard Bank branch and relationship manager's name";
                newContainer.appendChild(newLabel);
                var newInput = document.createElement('input');
                newInput.classList.add('js-manager-name');
                newInput.classList.add('form__input');
                newInput.classList.add('form__input--required');
                newInput.setAttribute('placeholder', "Enter your Standard Bank branch and relationship manager's name");
                newContainer.appendChild(newInput);
                parentParent.insertBefore(newContainer, parent_1.nextSibling);
            }
        }); });
        // input - date of company
        this.inputDateCompany.addEventListener('keyup', function (event) {
            var element = event.target;
            if (element.value) {
                _this.valuesJson.dateEstablished = element.value;
            }
        });
        // change - date of company
        this.inputDateCompany.addEventListener('change', function (event) {
            var element = event.target;
            if (element.value) {
                _this.valuesJson.dateEstablished = element.value;
            }
        });
        // radio buttons - relationship
        this.radioPrimaryBusiness.map(function (item) { return item.addEventListener('click', function (event) {
            var element = event.target;
            var parent = element.closest('.form__group');
            parent.classList.remove('form__group--error');
            if (element.value == "no") {
                _this.valuesJson.primeBusinessAfrica = 'N';
            }
            else {
                _this.valuesJson.primeBusinessAfrica = 'Y';
            }
        }); });
        // dropdown nationality
        this.dropdownTurnover.addEventListener('change', function (event) {
            var element = event.target;
            _this.valuesJson.companyAnnualTurnover = element.value;
        });
        // dropdown nationality
        this.dropdownEmployees.addEventListener('change', function (event) {
            var element = event.target;
            _this.valuesJson.employeesN = element.value;
        });
        // submit button
        this.submitButton.map(function (item) { return item.addEventListener('click', function (event) {
            var formModal = _this.element.closest('.js-apply-now-modal');
            _this.valueModalId = formModal.getAttribute('id');
            var formFields = _this.containerGroupCheckEligibility.querySelectorAll('input, select');
            var validation = _this.validationService.validateEnterprise(formFields);
            if (validation.valid) {
                if (_this.valuesJson.primeBusinessAfrica !== "") {
                    if (_this.valuesJson.clientSBG === 'Y') {
                        _this.applyFilters('callmeback', _this.valueModalId);
                    }
                    else {
                        if (_this.checkEligibility.validateDateEstablished(_this.inputDateCompany.value)) {
                            if (_this.valuesJson.primeBusinessAfrica === 'Y' && _this.valuesJson.companyAnnualTurnover !== 'Less than 1 million' && _this.valuesJson.employeesN !== 'Less than 10') {
                                _this.applyFilters('apply', _this.valueModalId);
                            }
                            else {
                                _this.containerFields.classList.add('hidden');
                                _this.containerThankyou.classList.add('active');
                                _this.containerInvalid.classList.add('active');
                                _this.checkEligibility.changeButtons('contactus', _this.valueModalId);
                                _this.analyticsService.dtmFormComplete('complete', '', true, 'Not Eligible');
                            }
                        }
                        else {
                            _this.containerFields.classList.add('hidden');
                            _this.containerThankyou.classList.add('active');
                            _this.containerInvalid.classList.add('active');
                            _this.checkEligibility.changeButtons('contactus', _this.valueModalId);
                            _this.analyticsService.dtmFormComplete('complete', '', true, 'Not Eligible');
                        }
                    }
                }
                else {
                    _this.radioPrimaryBusiness.map(function (item, index) {
                        var parent = item.closest('.form__group');
                        parent.classList.add('form__group--error');
                    });
                }
            }
        }); });
        // close button - reset form
        this.closeButton.addEventListener('click', function (event) {
            _this.containerInvalid.classList.remove('active');
            _this.containerValid.classList.remove('active');
            _this.containerValidExisting.classList.remove('active');
            $(document).find('div.js-manager-name-container').remove();
            _this.containerInvalid.classList.add('form-check-eligibility-business--hidden');
            _this.containerValid.classList.add('form-check-eligibility-business--hidden');
            _this.containerValidExisting.classList.add('form-check-eligibility-business--hidden');
        });
        $(document).on('click', "a.js-apply-now-modal-open[data-modal='" + this.valueModalId + "']", function (event) {
            var element = event.target;
            var parentAttribute = "";
            if (element.closest('.product-offering-exchange__button')) {
                parentAttribute = element.closest('.product-offering-exchange__button').getAttribute('data-buttonclass');
            }
            if (element.closest('.comparison-exchange__product__button')) {
                parentAttribute = element.closest('.comparison-exchange__product__button').getAttribute('data-buttonclass');
            }
            if (element.closest('.detailed-product-card-exchange__buttons-js')) {
                parentAttribute = element.closest('.detailed-product-card-exchange__buttons-js').getAttribute('data-buttonclass');
            }
            if (parentAttribute === 'Eligibility') {
                var type = $(element).attr('data-productname');
                var data = $(element).attr('data-text');
                var dataNewFormName = "checkeligibility | wealth business | " + type;
                if (data) {
                    var dataArray = data.split(" | ");
                    _this.formCheckEligibility.setAttribute('data-frmcontainer', dataNewFormName);
                }
                var modal = $(element).attr('data-modal');
                _this.valuesJson.pageUrl = window.location.href;
                if (type) {
                    _this.valuesJson.productName = type;
                }
                if (modal) {
                    _this.valuesJson.eligibilityFormId = modal;
                }
                _this.formstart();
                // APPLICATION ID
                var valueProductID = $(element).closest('.js-product-id').attr('data-productid');
                console.log('Modal ID', modal);
                console.log('Product ID', valueProductID);
                _this.checkEligibility.checkApplicationID(modal, valueProductID, dataNewFormName, type);
            }
        });
    };
    FormCheckEligibilityBusiness.prototype.applyFilters = function (type, modalId) {
        var typeValue = type;
        var modalIdValue = modalId;
        var containerLoader = this.containerLoader;
        var containerValidExisting = this.containerValidExisting;
        var containerThankyou = this.containerThankyou;
        var containerFields = this.containerFields;
        var containerValid = this.containerValid;
        var checkEligibility = this.checkEligibility;
        containerFields.classList.add('hidden');
        containerLoader.classList.add('active');
        // variables
        var response = 'invalid';
        // fields
        var operation = this.valuesJson.operation;
        var category = this.valuesJson.category;
        var leadType = this.valuesJson.leadType;
        var leadCTA = this.valuesJson.leadCTA;
        var eligibilityCTA = this.valuesJson.eligibilityCTA;
        var leadStatus = this.valuesJson.leadStatus;
        var eligibilityFormId = this.valuesJson.eligibilityFormId;
        var clientSBG = this.valuesJson.clientSBG;
        var sbPOR = '';
        if (this.element.querySelector('input.js-manager-name')) {
            var component = this.element.querySelector('input.js-manager-name');
            console.log(component);
            sbPOR = component.value;
        }
        var dateEstablished = this.valuesJson.dateEstablished;
        var primeBusinessAfrica = this.valuesJson.primeBusinessAfrica;
        var companyAnnualTurnover = this.valuesJson.companyAnnualTurnover;
        var employeesN = this.valuesJson.employeesN;
        var productName = this.valuesJson.productName;
        var pageUrl = this.valuesJson.pageUrl;
        var applicationID = this.checkEligibility.applicationID;
        var productID = this.checkEligibility.applicationProductID;
        // build string
        var postData = '';
        if (operation) {
            postData += 'operation=' + operation + '&';
        }
        if (category) {
            postData += 'category=' + category + '&';
        }
        if (leadType) {
            postData += 'leadType=' + leadType + '&';
        }
        if (leadCTA) {
            postData += 'leadCTA=' + leadCTA + '&';
        }
        if (eligibilityCTA) {
            postData += 'eligibilityCTA=' + eligibilityCTA + '&';
        }
        if (leadStatus) {
            postData += 'leadStatus=' + leadStatus + '&';
        }
        if (eligibilityFormId) {
            postData += 'eligibilityFormId=' + eligibilityFormId + '&';
        }
        if (clientSBG) {
            postData += 'clientSBG=' + clientSBG + '&';
        }
        if (sbPOR) {
            postData += 'sbPOR=' + sbPOR + '&';
        }
        if (dateEstablished) {
            var date = new Date(dateEstablished);
            var DD = (date.getDate() <= 9 ? '0' : '') + date.getDate();
            var MM = (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1);
            var YYYY = date.getFullYear();
            var value = DD + '/' + MM + '/' + YYYY;
            postData += 'dateEstablished=' + value + '&';
        }
        if (primeBusinessAfrica) {
            postData += 'primeBusinessAfrica=' + primeBusinessAfrica + '&';
        }
        if (companyAnnualTurnover) {
            postData += 'companyAnnualTurnover=' + companyAnnualTurnover + '&';
        }
        if (employeesN) {
            postData += 'employeesN=' + employeesN + '&';
        }
        if (productName) {
            postData += 'productName=' + productName + '&';
        }
        if (pageUrl) {
            postData += 'pageUrl=' + pageUrl + '&';
        }
        if (applicationID) {
            postData += 'appID=' + applicationID + '&';
        }
        if (productID) {
            postData += 'productID=' + productID + '&';
        }
        // config
        var analyticsService = new AnalyticsService();
        var url = "/services/SubmitWINLead.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            if (response.data === 'invalid') {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                containerLoader.classList.remove('active');
                containerFields.classList.remove('hidden');
                checkEligibility.changeButtons(typeValue, modalId, '');
            }
            else {
                var responseData = response.data;
                containerLoader.classList.remove('active');
                if (type === 'callmeback') {
                    containerValidExisting.classList.add('active');
                    containerThankyou.classList.add('active');
                    containerFields.classList.add('hidden');
                }
                else if (type === 'apply') {
                    containerValid.classList.add('active');
                    containerThankyou.classList.add('active');
                    containerFields.classList.add('hidden');
                }
                checkEligibility.changeButtons('callmeback', modalIdValue, responseData);
                analyticsService.dtmFormCompleteEligibility('complete', responseData.leadID, true, 'Eligible');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
        });
    };
    FormCheckEligibilityBusiness.prototype.resetForm = function () {
        if (this.formCheckEligibility) {
            this.formCheckEligibility.reset();
            var formContainerLoader = this.element.querySelector('.form__loader--container');
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            formContainerThankyou.classList.remove('active');
            formContainerFields.classList.remove('hidden');
        }
    };
    FormCheckEligibilityBusiness.prototype.formstart = function () {
        var dataNewFormName = "checkeligibility | wealth business | " + this.valuesJson.productName;
        this.analyticsService.dtmFormNameUpdate(dataNewFormName);
        this.analyticsService.dtmAllowFormRefresh();
    };
    return FormCheckEligibilityBusiness;
}(Base));
export { FormCheckEligibilityBusiness };



//////////////////
// WEBPACK FOOTER
// ./components/form-check-eligibility-business/form-check-eligibility-business.component.ts
// module id = 302
// module chunks = 0